import { render, staticRenderFns } from "./PurchasesCard.vue?vue&type=template&id=7e8f6ebe&scoped=true&"
import script from "./PurchasesCard.vue?vue&type=script&lang=js&"
export * from "./PurchasesCard.vue?vue&type=script&lang=js&"
import style0 from "./PurchasesCard.vue?vue&type=style&index=0&id=7e8f6ebe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8f6ebe",
  null
  
)

export default component.exports